<template>
  <li class="item-wrap" @click="goDetail">
    <div class="logo">
      <img src="../../assets/images/gaming/kog.png" alt="">
    </div>
    <div class="name">
      <el-tooltip class="item" effect="dark" :content="game.league" placement="top">
        <span>{{ game.league }}</span>
      </el-tooltip>
    </div>
    <div class="time">
      <div>{{ game.start_time_int | formatTime }}</div>
      <div class="bo">BO{{ game.bo }}</div>
    </div>
    <div class="state" :class="{ 'start': game.state === 2}">
      <template v-if="game.state === 1">
        未
      </template>
      <template v-if="game.state === 2 && game.info">
        <div v-if="game.info.index">第{{ game.info.index | numToCN}}局</div>
        <div>{{ (game.info.duration || 0) | secToMin }}<span class="move-dian">'</span></div>
      </template>
      <template v-if="game.state === 2 && !game.info">
        进行中
      </template>
      <template v-if="game.state === 3">
        完
      </template>
      <template v-if="game.state === 11">
        中断
      </template>
    </div>
    <div class="team">
      <div class="home">
        <img :src="game.home_logo" @error="onKogTeamLogoError" alt="">
        <span :title="game.home_team_name">{{ game.home_team_name }}</span>
      </div>
      <div class="away">
        <img :src="game.away_logo" @error="onKogTeamLogoError" alt="">
        <span :title="game.away_team_name">{{ game.away_team_name }}</span>
      </div>
    </div>
    <div class="score">
      <div class="home" :class="{'active': game.home_score > game.away_score}">
        <span>{{ game.state === 1 ? '-' : game.home_score }}</span>
      </div>
      <div class="away" :class="{'active': game.away_score > game.home_score}">
        <span>{{ game.state === 1 ? '-' : game.away_score }}</span>
      </div>
    </div>
    <div class="kill" v-if="routerType !== 'completed'">
      <template v-if="game.state === 2 && game.info">
        <div class="home">{{ game.info.home.kill_count }}</div>
        <div class="away">{{ game.info.away.kill_count }}</div>
      </template>
    </div>
    <div class="economy" v-if="routerType !== 'completed'">
      <template v-if="game.state === 2 && game.info">
        <div class="home">{{ (game.info.home.money > game.info.away.money ? game.info.home.money - game.info.away.money : '') | formatNumber}}</div>
        <div class="away">{{ (game.info.away.money > game.info.home.money ? game.info.away.money - game.info.home.money : '') | formatNumber }}</div>
      </template>
    </div>
    <div class="event">
      <div class="home" v-if="game.state === 2">
        <div>
          <img v-if="game.info && game.info.home.is_first_blood" src="../../assets/images/gaming/first_blood-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/first_blood-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.home.is_first_tower" src="../../assets/images/gaming/first_tower-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/first_tower-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.home.is_five_kills" src="../../assets/images/gaming/five_kills-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/five_kills-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.home.is_ten_kills" src="../../assets/images/gaming/ten_kills-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/ten_kills-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.home.is_first_tyrants" src="../../assets/images/gaming/first_small_dragon-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/first_small_dragon-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.home.is_first_dominates" src="../../assets/images/gaming/first_big_dragon-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/first_big_dragon-nor.png" alt="">
        </div>
      </div>
      <div class="away" v-if="game.state === 2">
        <div>
          <img v-if="game.info && game.info.away.is_first_blood" src="../../assets/images/gaming/first_blood-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/first_blood-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.away.is_first_tower" src="../../assets/images/gaming/first_tower-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/first_tower-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.away.is_five_kills" src="../../assets/images/gaming/five_kills-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/five_kills-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.away.is_ten_kills" src="../../assets/images/gaming/ten_kills-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/ten_kills-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.away.is_first_tyrants" src="../../assets/images/gaming/first_small_dragon-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/first_small_dragon-nor.png" alt="">
        </div>
        <div>
          <img v-if="game.info && game.info.away.is_first_dominates" src="../../assets/images/gaming/first_big_dragon-pre.png" alt="">
          <img v-else src="../../assets/images/gaming/first_big_dragon-nor.png" alt="">
        </div>
      </div>
    </div>
    <div class="video" v-if="routerType !== 'completed'">
      <div>
        <img v-if="game.is_tv || game.is_zb" src="../../assets/images/gaming/video.png" alt="">
      </div>
    </div>
    <div class="figure">
      <div class="home" :class="[homeClass, isHomeWin ? 'up' : '']">{{ game.home_odds_score }}</div>
      <div class="away" :class="[awayClass, isAwayWin ? 'up' : '']">{{ game.away_odds_score }}</div>
    </div>
    <div class="date">析</div>
    <div class="play" v-if="routerType !== 'completed'">
      <button v-if="['gaming', 'collect'].includes(routerType)" @click.stop="setTop(game)">
        <img v-if="kogTopIds.includes(game.tournament_id)" src="../../assets/images/gaming/top-pre.png" alt="">
        <img v-else src="../../assets/images/gaming/top-nor.png"/>
      </button>
      <button @click.stop="collect(game)">
        <img v-if="kogCollectIds.includes(game.tournament_id)" src="../../assets/images/gaming/collect-pre.png"/>
        <img v-else src="../../assets/images/gaming/collect-nor.png"/>
      </button>
    </div>
  </li>
</template>

<script>
import dayjs from 'dayjs'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'KogGameItem',
  props: {
    game: {
      type: Object,
    }
  },
  computed: {
    ...mapState(['kogTopIds', 'kogCollectIds']),
    routerType () {
      return this.$route.name
    },
    isHomeWin () {
      return this.game.state === 3 && this.game.home_score > this.game.away_score
    },
    isAwayWin () {
      return this.game.state === 3 && this.game.away_score > this.game.home_score
    }
  },
  filters:{
    secToMin(sec) {
      // 将秒数除以60，得到分钟数
      let min = sec / 60;
      // 使用 Math.floor 方法向下取整
      min = Math.floor(min);
      // 返回结果
      return min;
    },
    numToCN(num) {
      // 定义一个数组存储汉字
      const CN_CHARS = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      // 定义一个字符串存储结果
      let result = "";
      // 定义一个变量存储位数
      let digit = 0;
      // 使用一个循环遍历数字的每一位
      while (num > 0) {
        // 取出数字的最后一位
        let last = num % 10;
        // 根据位数和值拼接汉字
        if (digit === 0) {
          // 个位
          result = CN_CHARS[last] + result;
        } else if (digit === 1) {
          // 十位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加十和对应的汉字
            result = "十" + CN_CHARS[last] + result;
          }
        } else if (digit === 2) {
          // 百位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加百和对应的汉字
            result = "百" + CN_CHARS[last] + result;
          }
        }
        // 将数字除以10，去掉最后一位
        num = Math.floor(num / 10);
        // 将位数加一
        digit++;
      }
      // 返回结果
      return result;
    },
    formatTime(val) {
      return dayjs(val * 1000).format("HH:mm")
    },
    formatNumber(num) {
      return num >= 1000 ? (num / 1000).toFixed(1) + 'k' : num;
    }
  },
  watch: {
    'game.home_odds_score': function (val, oldVal) {
      if (val - oldVal > 0) {
        this.homeClass = 'up'
      } else if (val - oldVal < 0) {
        this.homeClass = 'down'
      }
      if (this.homeTimeOut) {
        clearTimeout(this.homeTimeOut)
      }
      this.homeTimeOut = setTimeout(() => this.homeClass = '', 2000)
    },
    'game.away_odds_score': function (val, oldVal) {
      if (val - oldVal > 0) {
        this.awayClass = 'up'
      } else if (val - oldVal < 0) {
        this.awayClass = 'down'
      }
      if (this.awayTimeOut) {
        clearTimeout(this.awayTimeOut)
      }
      this.awayTimeOut = setTimeout(() => this.awayClass = '', 2000)
    }
  },
  data () {
    return {
      homeClass: '',
      awayClass: '',
      homeTimeOut: null,
      awayTimeOut: null
    }
  },
  methods: {
    ...mapActions({
      setKogTop: 'setKogTop',
      setKogCollect: 'setKogCollect'
    }),
    setTop (game) {
      this.setKogTop(game.tournament_id)
    },
    collect (game) {
      this.setKogCollect(game.tournament_id)
    },
    goDetail() {
      if (this.game.state === 1) {
        window.open(`/live/kog?id=${this.game.tournament_id}&tab=${2}`)
      } else {
        window.open(`/live/kog?id=${this.game.tournament_id}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.item-wrap {
  text-align: center;
  align-items: center;
  .logo {
    width: 45px;
    margin-right: 35px;
    padding-left: 13px;
    img {
      width: 25px;
      height: 25px;
    }
  }
  .name {
    width: 105px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    text-align: left !important;
  }
  .time {
    width: 80px;
    color: #705B5D;
    .bo {
      color: #000;
    }
  }
  .state {
    width: 90px;
    &.start {
      color: #E65668;
      line-height: 16px;
    }
    .move-dian {
      margin-left: 2px;
    }
  }
  .team {
    width: 108px;
    padding-left: 24px;
    div {
      display: flex;
      align-items: center;
      gap: 5px;
      &.home {
        margin-bottom: 8px;
      }
      img {
        text-align: left;
        width: 22px;
        height: 22px;
      }
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 22px;
      }
    }
  }
  .score {
    width: 92px;
    .home {
      margin-bottom: 7px;
    }
    .active {
      span {
        color: #E65668;
      }
    }
    span {
      display: inline-block;
      padding: 5px;
      line-height: 14px;
      height: 24px;
      background: #FFFFFF;
      box-shadow: 1px 2px 4px 0px rgba(0,0,0,0.25);
      border-radius: 4px;
      font-size: 14px;
      color: #000;
    }
  }
  .kill {
    width: 41px;
    margin-right: 20px;
    font-size: 14px;
    color: #E65668;
    div {
      height: 32px;
      line-height: 32px;
    }
  }
  .economy {
    width: 61px;
    margin-right: 10px;
    font-size: 12px;
    div {
      height: 32px;
      line-height: 32px;
    }
  }
  .event {
    flex: 1;
    width: 206px;
    > div {
      display: flex;
      > div {
        width: 32px;
        height: 32px;
        img {
          width: 32px;
          height: 32px;
        }
      }
    }
  }
  .video {
    width: 63px;
    margin-right: 14px;
    img {
      width: 35px;
      height: 35px;
    }
  }
  .figure {
    width: 63px;
    margin-right: 10px;
    font-size: 12px;
    .home {
      margin-bottom: 13px;
    }
    .up {
      color: #E65668;
    }
    .down {
      color: #98CB4A;
    }
  }
  .date {
    width: 63px;
    margin-right: 22px;
  }
  .play {
    width: 63px;
    button {
      border: none;
      background: transparent;
      outline: none;
      padding: 5px;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>

<style lang="less">
.move-dian {
  animation-name: move-dian;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-delay: 0;
  -webkit-animation-name: move-dian;
  -webkit-animation-duration: 1.5s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-delay: 0;
  -moz-animation-name: move-dian;
  -moz-animation-duration: 1.5s;
  -moz-animation-timing-function: linear;
  -moz-animation-iteration-count: infinite;
  -moz-animation-fill-mode: forwards;
  -moz-animation-delay: 0;
  -o-animation-name: move-dian;
  -o-animation-duration: 1.5s;
  -o-animation-timing-function: linear;
  -o-animation-iteration-count: infinite;
  -o-animation-fill-mode: forwards;
  -o-animation-delay: 0;
}
@-webkit-keyframes move-dian {
	0% {
		opacity: 0;
	}

	30% {
		opacity: 1;
	}

	80% {
		opacity: 1;
	}

	100% {
		opacity: 0;
	}
}

@keyframes move-dian {
	0% {
		opacity: 0;
	}

	30% {
		opacity: 1;
	}

	80% {
		opacity: 1;
	}

	100% {
		opacity: 0;
	}
}
</style>
